export enum PartnerName {
	Veson = "veson",
	Ecdis = "ecdis",
	Erp = "erp"
  }